import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    ButtonGroup,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import {Close, RemoveDone, RemoveTwoTone} from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
    useApproveEmployeeReplacementRequestMutation,
    useListTemporarilyEmployeeReplacementApprovalRequestsQuery
} from "../store/umu/umuApi";
import copyObject from "../utils/copyObject";

export default function TempEmployeeApprovalRequestsPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const {data} = useListTemporarilyEmployeeReplacementApprovalRequestsQuery();
    const [copyOfData, setCopyOfData] = useState([]);
    const [approveReplacementRequest] = useApproveEmployeeReplacementRequestMutation();
    
    useEffect(() => {
        if (!data?.data)
            return;
        
        setCopyOfData(copyObject(data));
    }, [data])

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const handleSave = async () => {
        setIsSaving(true);

        // await createAttestation({courseId: id, startDate, endDate}).unwrap().then((fulfilled) => {
        //     if (fulfilled?.success) {
        //         navigate('/facultyattestations');
        //     } else {
        //         fulfilled.errors.map((item) => {
        //             alert(item);
        //             return 1;
        //         });
        //
        //         setIsSaving(false);
        //     }
        // });
    };
    
    async function approveRequest(request, approved) {
        const title = approved ? 'Утвердить замену' : 'Отклонить замену';
        
        // НЕ УДАЛЯТЬ КОММЕНТАРИЙ НИЖЕ! ЭТО ПРАВИЛО ESLINT
        // eslint-disable-next-line no-restricted-globals
        const result = confirm(title);
        if (!result) 
            return;
        
        // todo: send a request to backend
        setIsSaving(true);
        await approveReplacementRequest({data: {id: request.temporarilyEmployeeReplacementId, approved}}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
               request.approved = true;
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsSaving(false);
        }).catch(() => {
            setIsSaving(false);
            alert('Ошибка');
        });
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Заявки на смену нагрузки преподавателя`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {data === null || data === undefined ? <CircularProgress /> : <></>}
                            Заявки на смену нагрузки преподавателя
                        </Typography>
                    </Stack>

                    <Card>
                        <Table size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>№</TableCell>
                                    <TableCell>Дисциплина</TableCell>
                                    <TableCell>Группы</TableCell>
                                    <TableCell>Преподаватель по нагрузке</TableCell>
                                    <TableCell>Преподаватель на замещение</TableCell>
                                    <TableCell>Период замещения</TableCell>
                                    <TableCell>Утвердить</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {copyOfData?.data?.sort((l,r) => l.disciplineName > r.disciplineName ? 1 : -1).map((item, index) => {
                                    return item.approved 
                                        ? <></> 
                                        : <TableRow>
                                        <TableCell>{index+1}</TableCell>
                                        <TableCell>{item.disciplineName}<br /><small>{item.lessonTypeName}</small></TableCell>
                                        <TableCell>{item.groups.sort().join(', ')}<br /><small>{item.flowNumber} поток</small></TableCell>
                                        <TableCell>{item.originalEmployeeName}<br /><small>Кафедра {item.originalEmployeeChairName}</small></TableCell>
                                        <TableCell>{item.tempEmployeeName}<br /><small>Кафедра {item.tempEmployeeChairName}</small></TableCell>
                                        <TableCell>С {toDateString(item.validFrom)} по {!item.validTo ? 'неопределенный срок' : toDateString(item.validTo)}</TableCell>
                                        <TableCell>
                                            <ButtonGroup orientation={'horizontal'}>
                                                <IconButton color={'success'}
                                                            disabled={isSaving || item.approved}
                                                            onClick={() => {approveRequest(item, true)}}><CheckIcon /></IconButton>
                                                <IconButton color={'error'}
                                                            disabled={isSaving || item.approved}
                                                            onClick={() => {approveRequest(item, false)}}><Close /></IconButton>
                                            </ButtonGroup>
                                        </TableCell>
                                    </TableRow>
                                })}
                            </TableBody>
                        </Table>
                    </Card>

                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}